import {replaceAll} from 'chats'

export function getUserShortName(name: string | undefined): string {
  if (!name) return ''
  const chunks = name.split(' ')
  let initials = chunks
    .filter((c) => !!c)
    .map((c) => c[0])
    .join('')
  if (initials.length === 0) return 'N/A'
  return initials.toUpperCase()
}

export const profileFullName = (
  name?: string,
  surname?: string,
  splitByNewLine = false,
): string => {
  let title = ''
  if (name && name.length > 0) {
    title = `${name}`
  }

  if (surname && surname.length > 0) {
    if (title.length > 0 && !splitByNewLine) {
      title += ' '
    }
    if (splitByNewLine) {
      title += '\n'
    }
    title += `${surname}`
  }
  if (title.length === 0) {
    title = 'unknownUserName'
    if (splitByNewLine) {
      title = replaceAll(title, ' ', '\n')
    }
  }
  return title
}
